/**
 * Plain string arrays for contact types. Extracted from contactTypeConfig.js
 * so non-UI modules (storage, services) can import without pulling in
 * Phosphor icon dependencies.
 */

// All real contact types (excludes chat and custom)
export const CONTACT_FIELDS = [
  'phone',
  'whatsapp',
  'instagram',
  'telegram',
  'signal',
  'email',
  'website',
  'linkedin',
  'facebook',
  'github',
  'snapchat',
  'substack',
  'tiktok',
  'twitch',
  'twitter',
  'youtube',
];

// All contact keys including secondary variants and custom — for filtering userData
export const ALL_CONTACT_KEYS = [
  ...CONTACT_FIELDS,
  'phone2',
  'email2',
  'instagram2',
  'whatsapp2',
  'custom',
];

// Secondary variants (phone2, email2, …) collapse to their base type for
// icons/labels/links. One implementation — was inlined in 4 files (refactor
// log 2026-06-12, consolidated on b/exchange-social-track).
export const getBaseType = (type) => (type || '').replace(/2$/, '');

// Open a contact link the right way per scheme. Lives here (not the icon
// registry, which re-exports it) so chat components can import it without
// pulling in every Phosphor icon — that also breaks Jest's SSR-icon resolution.
export const openContactLink = (link) => {
  if (link.startsWith('mailto:') || link.startsWith('tel:') || link.startsWith('sms:')) {
    window.location.href = link;
  } else {
    window.open(link, '_blank', 'noopener,noreferrer');
  }
};

// Always available in the Anon sharing dropdown, regardless of what Profile shared
export const BASELINE_TYPES = ['phone', 'whatsapp', 'instagram', 'email'];

// Relevance hierarchy for multi-contact reciprocity
export const RELEVANCE_ORDER = ['phone', 'whatsapp', 'instagram', 'telegram', 'signal', 'email'];

// The share sheet + composer tray's lead ordering (mock ruling, social-track
// 2026-07-16). Deliberately different from RELEVANCE_ORDER: this ranks which
// of MY channels lead when sharing, not which of the peer's to reciprocate.
export const SHEET_SHARE_ORDER = [
  'phone',
  'instagram',
  'whatsapp',
  'email',
  'linkedin',
  'substack',
];
